import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {saveEventThunk} from '~/CreateFabricInvitation/api/event';
import {selectIsPremiumTemplate} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {eventIsPremium} from '~/common/fabric/reducers/details/selectors';
import {UPDATE_PLEDGELING_OPTIONS} from '~/common/fabric/reducers/giftingOptions/constants';
import {
  selectGiftingOptionsUpgraded,
  selectShowGifting,
} from '~/common/fabric/reducers/giftingOptions/selectors';
import {isJson} from '~/common/utils';
import {
  TURN_OFF_DONATION_LOADING,
  TURN_ON_DONATION_LOADING,
} from '~/ViewInvitation/reducers/constants';
import {scrollElementIntoViewById} from '~library/utils/misc';

export const MessageListener = () => {
  const isPremium = useSelector(eventIsPremium);
  const isPremiumTemplate = useSelector(selectIsPremiumTemplate);
  const showGifting = useSelector(selectShowGifting);
  const giftingOptionsUpgraded = useSelector(selectGiftingOptionsUpgraded);
  const dispatch = useDispatch();

  useEffect(() => {
    const listener = async (e) => {
      if (e.origin.includes('pledge') && isJson(e.data)) {
        const {action, data: payload} = JSON.parse(e.data);

        const embedCodes = document.querySelectorAll('.plg-search, .plg-crowd');
        const embedCode = Array.from(embedCodes).find(
          (code) => code.firstElementChild.contentWindow === e.source
        );

        switch (action) {
          case 'updateEvent': {
            // Turn on donation loading spinner
            dispatch({type: TURN_ON_DONATION_LOADING});

            dispatch({
              type: UPDATE_PLEDGELING_OPTIONS,
              payload,
            });
            scrollElementIntoViewById('module-donation');
            await dispatch(saveEventThunk(true, 5000));
            // Turn off donation loading spinner
            dispatch({type: TURN_OFF_DONATION_LOADING});

            break;
          }

          case 'removeEvent': {
            if ([...embedCode.classList].includes('plg-search')) {
              dispatch({
                type: UPDATE_PLEDGELING_OPTIONS,
                // biome-ignore lint/style/useNamingConvention: existing error
                payload: {beneficiary_type: 'Organization'},
              });
            } else {
              dispatch({
                type: UPDATE_PLEDGELING_OPTIONS,
                // biome-ignore lint/style/useNamingConvention: existing error
                payload: {beneficiary_type: 'Crowdfund'},
              });
            }
            await dispatch(saveEventThunk(true));

            break;
          }
          default:
            break;
        }
      }
    };

    if (isPremium && !isPremiumTemplate && !showGifting && giftingOptionsUpgraded === false) {
      dispatch({
        type: 'UPDATE_GIFT_OPTIONS',
        payload: {
          upgraded: true,
        },
      });

      dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {isPremium: true},
      });
    }

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [isPremium, isPremiumTemplate, showGifting, giftingOptionsUpgraded, dispatch]);

  return null;
};
